
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/categoria/[categorySlug]/[page]",
      function () {
        return require("private-next-pages/categoria/[categorySlug]/[page].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/categoria/[categorySlug]/[page]"])
      });
    }
  